import React from 'react';
import { FaHome, FaExclamationTriangle } from 'react-icons/fa';
import { Button, Col, Container, Row } from 'react-bootstrap/esm';
import { useNavigate } from 'react-router-dom';

const ServerError: React.FC = () => {
  const navigate = useNavigate();

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Container className="min-vh-100 d-flex align-items-center">
      <Row className="w-100">
        <Col className="text-center">
          <div className="error-page">
            <FaExclamationTriangle className="text-danger mb-4" size={80} />
            <h1 className="display-1 text-danger mb-4">500</h1>
            <h2 className="mb-3">Erro interno do servidor</h2>
            <p className="lead text-muted mb-4">
              Ocorreu um erro inesperado. Nossa equipe foi notificada e está trabalhando para resolver o problema.
            </p>
            <div className="d-flex justify-content-center gap-3">
              <Button 
                variant="danger" 
                onClick={handleRefresh}
                className="d-flex align-items-center gap-2"
              >
                <FaHome />
                Tentar novamente
              </Button>
              <Button 
                variant="outline-primary" 
                onClick={() => navigate('/')}
                className="d-flex align-items-center gap-2"
              >
                <FaHome />
                Início
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ServerError;
